import axios from 'axios'

export default {
    index (data) {
        return axios.post('/api/counters', data)
    },
    export (data) {
        return axios.post('/api/counters/export', data, {
            responseType: "blob",
        })
    }
}